import { constants } from "../config/constants"
export default {
  methods: {
    $init(token, data) {
      /* AUTH */
      this.$store.commit("auth/SET_CURRENT_USER", {
        user: data,
        token: token
      })

      /* SETTINGS */
      this.$store.dispatch("settings/init", data.settings)
      let locale = this.$getSetting("locale")

      /* FRONT END LOCALE */
      let fe_locale = this.$store.getters["settings/fe_locale"]
      let path = this.$router.currentRoute.path

      if ((path.startsWith("/f/") || path.startsWith("/auth/")) && fe_locale) {
        // If previous route path is login page, use the locale from the user's settings
        if (path.startsWith("/auth/") && path.endsWith("/login")) {
          locale = locale
        } else {
          locale = fe_locale
        }
      }
      this.$i18n.locale = locale
    },
    $isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    $setPageTitle: function (title) {
      this.$store.dispatch("master/setPageTitle", title)
    },
    $setCurrentModule: function (module) {
      this.$store.dispatch("master/setCurrentModule", module)
    },
    $toggleDrawer: function (bool = undefined) {
      let drawer = this.$store.getters["master/drawerOpen"]
      drawer = !drawer

      if (bool !== undefined) {
        drawer = bool
      }

      this.$store.dispatch("master/setDrawerOpen", drawer)
    },
    $globalMessages(message, type, show = true, code = null, extras = null) {
      this.$store.dispatch("master/setAlert", {
        message: message,
        type: type == "" ? "success" : type,
        show: show,
        code: code,
        extras: extras
      })
    },
    $formatErrorMessages(errors) {
      let messages = ""

      if (typeof errors === "string") {
        messages = errors
      } else {
        _.map(errors, function (data) {
          messages += _.map(data).join("\n\t")
        })
      }

      return messages
    },
    $setAuthorization(token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
    },
    $checkAllCookies() {
      let access_token = this.$cookies.get(`${this.COOKIE_PREFIX}access_token`)

      if (access_token) {
        return true
      }

      return false
    },
    $clearCookies() {
      this.$cookies.remove(`${this.COOKIE_PREFIX}access_token`)
    },
    $can: function (action, local = false) {
      let vm = this
      let bool = false
      let user = local ? this.$store.getters["auth/localUser"] : this.$store.getters["auth/user"]

      _.forEach(user.roles, function (role) {
        if (role.slug == "system-developer") bool = true

        if (!bool) {
          _.forEach(role.permissions, function (permission) {
            if (permission == action) bool = true
          })
        }
      })

      return bool
    },
    $hasRole: function (action, exclude_sysdev = false) {
      let bool = false
      let user = this.$store.getters["auth/user"]
      if (!user) {
        user = this.$store.getters["auth/localUser"]
      }

      _.forEach(user.roles, function (role) {
        if (exclude_sysdev) {
          if (role.slug == action) bool = true
        } else {
          if (role.slug == action || role.slug == "system-developer") bool = true
        }
      })

      return bool
    },
    $isAdmin: function () {
      let isAdmin = this.$hasRole("system-developer") || this.$hasRole("superuser")
      return isAdmin
    },
    $isUser: function () {
      let bool = this.$hasRole("user")
      return bool
    },
    $addLog: function (user_id, action_model, action_id, action, before_value = "", after_value = "") {
      let user = this.$store.getters["auth/localUser"]

      axios
        .post(this.API_URL + "log", {
          user_id: user_id ? user_id : user.id,
          action: action,
          action_model: action_model,
          action_id: action_id,
          before_value: before_value,
          after_value: after_value
        })
        .then((res) => { })
        .catch((err) => console.log(err))
    },
    $getCity(code, country) {
      if (country) {
        country = this.countryAlpha2(country)
      }

      if (!country) {
        country = "NO"
      }

      let bringAxios = axios.create({
        headers: {
          "X-MyBring-API-Uid": this.BRING_API_UID,
          "X-MyBring-API-Key": this.BRING_API_KEY
        }
      })

      return bringAxios.get(this.BRING_API_URL + `postalCode/${country}/getCityAndType/${code}.json`)
    },
    $queryString: function (pagination, search_params) {
      let sort_by = "",
        sort_order = "asc"
      let queryString = Object.keys(search_params)
        .map((key) => "query_" + key + "=" + (search_params[key] === undefined ? "" : search_params[key]))
        .join("&")

      if (pagination.multisort) {
      } else {
        if (pagination.sortBy.length == 1) {
          sort_by = pagination.sortBy[0]
        }

        if (pagination.sortDesc && pagination.sortDesc.length == 1) {
          sort_order = pagination.sortDesc[0] ? "desc" : "asc"
        }
      }

      let query = `page=${pagination.page}&sort_by=${sort_by}&sort_order=${sort_order}&rows_per_page=${pagination.itemsPerPage}&${queryString}`

      return query
    },
    $getLocalStorage(key, type) {
      let item = localStorage.getItem(key)

      if (item) {
        return item
      }

      // defaults
      if (type == 'page') {
        return 1;
      }
    },
    $getSetting: function (key) {
      let user = localStorage.getItem("__crrntUser")

      if (user) {
        user = JSON.parse(user)

        let setting = user.settings.find((i) => i.key == key)
        if (setting && setting.value) {
          if (key == "rows_per_page") {
            return Number(setting.value)
          }

          return setting.value
        }
      }

      // return default value
      if (key == "rows_per_page") {
        return constants.SETTING_DEFAULT_ROWS_PER_PAGE
      }
      if (key == "locale") {
        return constants.SETTING_DEFAULT_LOCALE
      }
    },
    $updateSetting: function (key, value) {
      this.$store.dispatch("settings/update", { key: key, value: value })
    },
    $updateSettingDB: function (key, value) {
      this.$store.dispatch("settings/updatedb", { key: key, value: value })
    },
    $localeChange(locale) {
      let vm = this

      let user = this.$store.getters["auth/user"]
      let data = []

      data.push({ key: "locale", value: locale })

      axios
        .post(this.API_URL + "setting", {
          user_id: user.id,
          data: JSON.stringify(data)
        })
        .then((res) => {
          vm.$i18n.locale = locale
          vm.$updateSetting("locale", locale)
        })
        .catch((err) => console.log(err))
    },
    $classFormatDuration: function (data) {
      let duration = data.duration
      let duration_type = data.duration_type

      return duration + " " + this.$dd_classes_duration_type(duration_type)
    },
    $getDefaultDropdown: function (data) {
      let item = data.find((i) => i.default == 1)

      return item ? item.key : null
    },
    $formatBytes: function (bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes"

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    },
    $dateFormatSetter: function (val, format = null) {
      if (format == null) {
        format = this.DATE_FORMAT
      }

      let checker = this.moment(val, format, true)
      let date = val

      if (checker.isValid()) {
        date = this.moment(val, format).format(this.MYSQL_DATE_FORMAT)
      }

      return date
    },
    $dateFormatGetter: function (val, format = this.MYSQL_DATE_FORMAT) {
      return this.moment(val, format, true).isValid() ? this.moment.utc(val).format(this.DATE_FORMAT) : val
    },
    $timeFormatSetter: function (val, format = null) {
      if (format == null) {
        format = this.TIME_FORMAT
      }

      let checker = this.moment(val, format, true)
      let time = val

      if (checker.isValid()) {
        time = this.moment(val, format).format(this.TIME_FORMAT)
      }

      return time
    },
    $timeFormatGetter: function (val, format = this.MYSQL_TIME_FORMAT) {
      return this.moment(val, this.MYSQL_TIME_FORMAT, true).isValid()
        ? this.moment.utc(val, this.TIME_FORMAT).format(this.TIME_FORMAT)
        : val
    },
    $keyDown_IntOnly: function (event) {
      event = event ? event : window.event
      var charCode = event.which ? event.which : event.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        event.preventDefault()
      } else {
        return true
      }
    },
    $locale_bcp47: function (val) {
      let locale = this.$getSetting("locale")

      if (val) locale = val

      if (locale == "no") locale = "nb"

      return locale
    },
    $generateUUID: function () {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },
    $diffObj: function (object, base) {
      function changes(object, base) {
        return _.transform(object, function (result, value, key) {
          if (!_.isEqual(value, base[key])) {
            result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value
          }
        })
      }
      return changes(object, base)
    },
    $leaveFormConfirmation: function (next, obj1, obj2, action, formValid = true) {
      if (!_.isEqual(obj1, obj2)) {
        this.$awn.confirm(
          this.$t("global.save_changes"),
          () => {
            action()

            if (formValid) {
              next()
            } else {
              next(false)
            }
          },
          () => {
            next()
          },
          {
            labels: {
              confirmOk: this.$t("global.yes"),
              confirmCancel: this.$t("global.no")
            }
          }
        )
      } else {
        next()
      }
    },

    $encryptString: function (text, salt = "B@mRo1*#lsa") {
      const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0))
      const byteHex = (n) => ("0" + Number(n).toString(16)).substr(-2)
      const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code)
      return text
        .split("")
        .map(textToChars)
        .map(applySaltToChar)
        .map(byteHex)
        .join("")
    },

    $decryptString: function (encoded, salt = "B@mRo1*#lsa") {
      const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0))
      const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code)
      return encoded
        .match(/.{1,2}/g)
        .map((hex) => parseInt(hex, 16))
        .map(applySaltToChar)
        .map((charCode) => String.fromCharCode(charCode))
        .join("")
    },

    // PUSH NOTIFICATION HELPERS
    $togglePushNotification: function (bool) {
      this.$store.commit("master/TOGGLE_PUSH_NOTIFICATION", bool)
    },
    $getPushNotificationItem: function (id) {
      return axios.get(this.API_URL + "pushnotification/" + id)
    },
    $getPushNotificationItemByUUID: function (uuid) {
      return axios.get(this.API_URL + "pushnotification/uuid/" + uuid)
    },
    $updatePushNotificationItem: function (id, data) {
      let udata = { id: id }

      _.forEach(data, function (value, key) {
        udata[key] = value
      })

      return axios.put(this.API_URL + "pushnotification", udata)
    },
    $setPushNotificationToInactive: function (uuid) {
      return axios.put(this.API_URL + "pushnotification/cancel/" + uuid)
    },
    $myPushNotifications: async function (timeout = null) {
      let vm = this
      let user = localStorage.getItem("__crrntUser")
      let toggle = this.$store.getters["master/togglePushNotification"]

      if (user && toggle) {
        user = JSON.parse(user)

        await axios
          .get(this.API_URL + "pushnotification/my/" + user.id)
          .then((res) => {
            let data = res.data.data

            _.forEach(data, function (item) {
              if (item.type == "confirmation") {
                // Set confirmation message
                let confirmation_message = ""

                let custom_data_1_yes = null
                let custom_data_1_no = null
                let custom_data_2_yes = null
                let custom_data_2_no = null
                let custom_data_3_yes = null
                let custom_data_3_no = null

                if (item.action == "qrcode-view-userprofile") {
                  confirmation_message = vm.$t("users.qr_confirmation_view_data", { name: item.created_by_name })
                  custom_data_1_yes = "approved"
                  custom_data_1_no = "rejected"
                }

                // Pause push notification and wait for the user to select a confirmation
                vm.$togglePushNotification(false)
                clearTimeout(timeout)

                // Show confirm dialog
                vm.$awn.confirm(
                  confirmation_message,
                  () => {
                    // Yes
                    vm.$setPushNotificationToInactive(item.uuid).then(() => {
                      // Update custom data if any
                      vm.$updatePushNotificationItem(item.id, {
                        custom_data_1: custom_data_1_yes,
                        custom_data_2: custom_data_2_yes,
                        custom_data_3: custom_data_3_yes
                      })

                      // Resume fetching of push notification
                      vm.$togglePushNotification(true)
                      clearTimeout(timeout)
                      vm.$myPushNotifications()
                    })
                  },
                  () => {
                    // No
                    // Resume fetching of push notification
                    vm.$setPushNotificationToInactive(item.uuid).then(() => {
                      // Update custom data if any
                      vm.$updatePushNotificationItem(item.id, {
                        custom_data_1: custom_data_1_no,
                        custom_data_2: custom_data_2_no,
                        custom_data_3: custom_data_3_no
                      })

                      vm.$togglePushNotification(true)
                      vm.$myPushNotifications()
                    })
                  },
                  {
                    labels: {
                      confirmOk: vm.$t("global.yes"),
                      confirmCancel: vm.$t("global.no")
                    }
                  }
                )
              } else {
              }
            })
          })
          .catch((err) => console.log(err))
      }

      timeout = setTimeout(function () {
        vm.$myPushNotifications(timeout)
      }, 3000)
    },
    $cookieChecker: function (name, func) {
      let vm = this

      if ($cookies.isKey(name)) {
        setTimeout(function () {
          vm.$cookieChecker(name, func)
        }, 3000)
      } else {
        func()
      }
    },
    $getAppVersion: function () {
      return process.env.VUE_APP_VERSION
    },
    $checkAppVersion() {
      let vm = this

      vm.$store.dispatch("master/setAxiosHideLoader", true)

      axios
        .get(vm.API_URL + "version")
        .then((res) => {
          let api_version = res.data.version
          let app_version = process.env.VUE_APP_VERSION
          let isnew = api_version != app_version

          vm.$store.dispatch("master/setNewVersionSnackbar", isnew)
        })
        .catch((err) => console.log(err))
    },
    $api1881SearchVAT(search) {
      let api1881Axios = axios.create({
        headers: {
          "Ocp-Apim-Subscription-Key": this.API1881_API_KEY,
        }
      })

      return api1881Axios.get(this.API1881_API_URL + `/lookup/organizationnumber/${search}`)
    },
    $api1881SearchName(search) {
      let api1881Axios = axios.create({
        headers: {
          "Ocp-Apim-Subscription-Key": this.API1881_API_KEY,
        }
      })

      return api1881Axios.get(this.API1881_API_URL + `/search/company?query=${search}&limit=10`)
    },
    $isValidJSONString(str) {
      try {
        JSON.parse(str)
        return true
      } catch (e) {
        return false
      }
      return true
    },
    $arrayBufferValidation(string) {
      let data = this.$arrayBufferToString(string)

      try {
        if (this.$isValidJSONString(data) && data) {
          var json = JSON.parse(data)

          if (json.status == "error") {
            let errors = this.$formatErrorMessages(json.message || this.$t("auth.error"))
            this.$globalMessages(errors, "error")
            window.scrollTo({ top: 0, behavior: "smooth" })
          }

          return false
        }
      } catch (e) {
        return true
      }

      return true
    },
    $arrayBufferToString(buffer) {
      try {
        return String.fromCharCode.apply(null, new Uint8Array(buffer))
      } catch (e) {
        return null
      }
    },
    $dataURLtoFile: function (dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }

      return new File([u8arr], filename, { type: mime })
    },
    $getFileExtension(fileName) {
      if (fileName) {
        var index = fileName.lastIndexOf(".")
        if (index >= 0) return fileName.substr(index + 1).toLowerCase()
      }

      return fileName
    },
    $getFileName(fileName) {
      if (fileName) fileName = fileName.replace(/\.[^/.]+$/, "")

      return fileName
    },
    $hasPreview(filename) {
      let valid_ext = ["jpg", "jpeg", "png", "heic", "pdf"]
      let ext = this.$getFileExtension(filename)
      return valid_ext.includes(ext)
    },
    $calculateAspectRatioFit: function (srcWidth, srcHeight, maxWidth, maxHeight) {
      var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight)

      return { width: srcWidth * ratio, height: srcHeight * ratio }
    },
    $slug(val) {
      if (val) {
        return val
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/[^\w-]+/g, "")
      }

      return null
    },
    $formatPhoneNumber(mobile, code) {
      let data = null

      if (mobile && code) {
        mobile = mobile.replace(/[^0-9]+/g, '')
        data = "+" + code + mobile
      }

      return data
    },
    $getMatchGrade(...args) {
      let match = 0
      let grade = 0

      for (let index = 0; index < args.length; index++) {
        let data = args[index]
        if (data.length == 2 && data[0] == data[1]) {
          match++
        }
      }

      grade = (match / args.length) * 100
      return grade
    },
    $formatAPICompanyName(str) {
      let abbrWords = /^(AS|ASA|A\/S|DA|AB|SRL|SA)$/i;
      let words = str.split(' ');  

      words = words.map(function(word, index) {
        if (index > 0 && ~word.search(abbrWords)) {
          return word;                 // If it's a small word, don't change it.
        }
        
        if (~word.lastIndexOf('.', 1)) { // If it contains periods, it's an abbreviation: Uppercase.
          return word.toUpperCase();   // lastIndexOf to ignore the last character.
        }

        // Capitalize the fist letter if it's not a small word or abbreviation.
        return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase(); 
      });
      
      return words.join(' ');
    }
  }
}
